module.exports = __webpack_public_path__ + "static/media/Temp baker-steel-electrum.3d9c2c74.csv";